export default __webpack_public_path__ + "static/media/player-preview.0716b0af.jpg";